import { get } from "../common/apiClient";

const PATH_COURSE = "/course";

/**
 * Get all courses with pagination
 * @param {Object} params - { page, limit, query }
 * @returns {Promise} - { data, totalItems, totalPages, currentPage }
 */
export const getCourses = async (params = {}) => {
  const { page = 1, limit = 6, query = "" } = params;
  const queryString = new URLSearchParams({ page, limit, query }).toString();
  return await get(`${PATH_COURSE}?${queryString}`);
};

/**
 * Get course by ID
 * @param {string} courseId
 * @returns {Promise}
 */
export const getCourseById = async (courseId) => {
  return await get(`${PATH_COURSE}/get-course/${courseId}`);
};
